import { createSlice } from "@reduxjs/toolkit"


const initialData={
errorMessage:""
}

const errorHandle=createSlice({
      name: "errorHandle",
      initialState: initialData,
      reducers: {
        addErrorMessage: (state, action) => {
          state.errorMessage = action.payload;
        },
        cleareApiError:(state)=>{
            state.errorMessage = null
        }
       
      },
})

export const { addErrorMessage ,cleareApiError} = errorHandle.actions;
export default errorHandle.reducer;